import tw from 'twin.macro';
import { Link } from 'gatsby';

const NavLink = tw(
  Link
)`text-xl md:(text-2xl) lg:(text-3xl) text-white rounded-lg font-bold block w-full text-center py-3 hover:(underline text-blue-100) focus:(outline-none ring-4 ring-green ring-opacity-60)`;

export default NavLink;
